<template>
  <Transition name="btt">
    <button
      v-show="visible"
      type="button"
      class="fixed bottom-6 right-6 z-50 grid h-12 w-12 place-items-center rounded-full bg-jelly-500 text-white shadow-lg shadow-jelly-500/40 transition-colors duration-300 hover:bg-jelly-600"
      aria-label="Back to top"
      @click="toTop"
    >
      <CustomIcon name="arrow-up" class="h-5 w-5" />
    </button>
  </Transition>
</template>

<script setup>
import CustomIcon from '@/components/base/CustomIcon.vue';
import { useScrolledPast } from '@/composables/useScrolledPast';
import { prefersReducedMotion } from '@/utils/motion';

const visible = useScrolledPast(600);

function toTop() {
  window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
}
</script>

<style scoped lang="scss">
.btt-enter-active,
.btt-leave-active {
  transition:
    opacity var(--dur-fast) ease,
    transform var(--dur-fast) ease;
}

.btt-enter-from,
.btt-leave-to {
  opacity: 0;
  transform: translateY(1rem) scale(0.8);
}
</style>
